var map = {
	"./BDS Markets Logo green.favicon.png": 19192,
	"./BDS_Markets_Logo_green.png": 45825,
	"./BDS_Markets_Logo_green_dark_theme.png": 23759,
	"./Black_Account_Icons-01.png": 49899,
	"./Black_Account_Icons-02.png": 33282,
	"./Black_Account_Icons-03.png": 84444,
	"./Black_Account_Icons-04.png": 3792,
	"./Black_Account_Icons-05.png": 84094,
	"./Black_Account_Icons-06.png": 36124,
	"./Calculator.svg": 12814,
	"./CalculatorBlue.svg": 42305,
	"./CalculatorDark.svg": 83137,
	"./Cashbags.svg": 21997,
	"./CashbagsBlue.svg": 60564,
	"./CashbagsDark.svg": 22705,
	"./ProcessingTime.svg": 26585,
	"./ProcessingTimeBlue.svg": 87290,
	"./ProcessingTimeDark.svg": 82788,
	"./RoundBlueCheckmark.png": 48374,
	"./RoundBlueCheckmarkDark.png": 80647,
	"./accountsBottomNav.svg": 21140,
	"./accuracyAccountsDemo_downloadMT4.jpg": 32205,
	"./accuracyAccountsReal_downloadMT4.jpg": 90119,
	"./addNewAccount.svg": 12736,
	"./alert@2x.svg": 88248,
	"./android-icon.svg": 30714,
	"./android_APK_filled.svg": 8286,
	"./app_store_filled.svg": 73279,
	"./apple-brands.svg": 80201,
	"./arrow-left.svg": 64210,
	"./arrow-transactions.svg": 78681,
	"./arrows_left_right.svg": 35337,
	"./autochartistTool.png": 8316,
	"./back-button-dark.svg": 62242,
	"./back-button-light.svg": 50543,
	"./bankWire.svg": 38649,
	"./bannerResearchAnalysis.png": 86726,
	"./bannerTelegramChannel.png": 65404,
	"./bannerTradingAcademy.png": 68786,
	"./bannerTradingTools.png": 12681,
	"./bdswissDemo_downloadMT4.png": 97717,
	"./bdswissGlobalDemo_downloadMT4.png": 60689,
	"./bdswissGlobalReal02_downloadMT4.png": 56542,
	"./bdswissGlobalReal03_downloadMT4.png": 61417,
	"./bdswissGlobalReal04_downloadMT4.png": 98152,
	"./bdswissGlobalReal05_downloadMT4.png": 11922,
	"./bdswissGlobalReal_downloadMT4.png": 22495,
	"./bdswissGlobalReal_downloadMT5.png": 34021,
	"./bdswissReal02_downloadMT4.png": 33493,
	"./bdswissReal03_downloadMT4.png": 64555,
	"./bdswissReal04_downloadMT4.png": 35438,
	"./bdswissReal05_downloadMT4.png": 73174,
	"./bdswissReal_downloadMT4.png": 44080,
	"./bdswissReal_downloadMT5.png": 49904,
	"./bdswissSCDemo_downloadMT4.png": 55830,
	"./bdswissSCReal01_downloadMT4.png": 4595,
	"./bdswissSCReal02_downloadMT4.png": 48441,
	"./bdswissSCReal03_downloadMT4.png": 30376,
	"./bdswissSCReal04_downloadMT4.png": 52691,
	"./bdswissSCReal05_downloadMT4.png": 91572,
	"./bdswiss_app_logo.svg": 60699,
	"./bdswiss_grey.png": 86648,
	"./bdswiss_white.png": 48907,
	"./bento-menu/bento-menu-icon.svg": 80862,
	"./bento-menu/bento-partner-portal-icon.svg": 39764,
	"./bento-menu/bento-telegram-icon.svg": 17869,
	"./bento-menu/bento-trading-central-icon.svg": 3241,
	"./bento-menu/bento-website-icon.svg": 96540,
	"./bento-menu/bento-webtrader-icon.svg": 78480,
	"./bento-qrcode-mob.svg": 93421,
	"./bg-carousel-1-dark.jpg": 17483,
	"./bg-carousel-1.jpg": 7504,
	"./bg-carousel-2-dark.jpg": 21964,
	"./bg-carousel-2.jpg": 1627,
	"./bg-carousel-3-dark.jpg": 89371,
	"./bg-carousel-3.jpg": 39227,
	"./bg-carousel-4-dark.jpg": 30603,
	"./bg-carousel-4.jpg": 54525,
	"./bg-image-affiliate-white.png": 96216,
	"./bg-image-affiliate.png": 98213,
	"./bitwallet-bdSwiss-dark.svg": 55926,
	"./bitwallet-bdSwiss-light.svg": 80716,
	"./bitwallet-swissMarkets-dark.svg": 95964,
	"./bitwallet-swissMarkets-light.svg": 31475,
	"./callback.svg": 71921,
	"./card.svg": 35129,
	"./check.svg": 50535,
	"./check_circle.png": 53198,
	"./chevron.svg": 61667,
	"./chevron_right.svg": 85808,
	"./chf.png": 27556,
	"./close-icon-dark.svg": 34707,
	"./close-icon-light.svg": 82596,
	"./close.svg": 37674,
	"./competitions.png": 18267,
	"./complimentary@2x.svg": 76820,
	"./contact_arrow.svg": 27138,
	"./contact_star.svg": 62771,
	"./control-radio-off.png": 17581,
	"./control-radio-on.png": 63204,
	"./copy-trading-icon.svg": 66862,
	"./copyLink.svg": 58108,
	"./copyLinkNew.svg": 77641,
	"./crypto.svg": 53199,
	"./cvv.svg": 38709,
	"./dashboardBottomNav.svg": 37318,
	"./deposit-card.svg": 30666,
	"./deposit-icon.svg": 23601,
	"./deposit_download.svg": 63105,
	"./diners.png": 86732,
	"./dkk.png": 38880,
	"./document-jpeg.png": 22025,
	"./document-jpg.png": 97861,
	"./document-pdf.png": 73572,
	"./document-png.png": 76550,
	"./document-upload-failure-dark.png": 41294,
	"./document-upload-failure-light.png": 47540,
	"./document-upload-success-black.png": 23740,
	"./document-upload-success-dark.png": 15418,
	"./document-upload-success-light.png": 53130,
	"./documents-empty-dark.png": 41510,
	"./documents-empty-light.png": 95385,
	"./download-apk.svg": 54054,
	"./download-app-icon.svg": 37797,
	"./download-playstore-dark.svg": 61676,
	"./download-playstore.svg": 36057,
	"./downloadPdf-light.png": 99413,
	"./downloadPdf.png": 25390,
	"./dpWorldTourChampionship-dark.svg": 89503,
	"./dpWorldTourChampionship-light.svg": 77553,
	"./eWallet.svg": 27599,
	"./ebookTool.png": 732,
	"./economicCalendarTool.png": 56479,
	"./educationalVideos-dark.svg": 45953,
	"./educationalVideos-light.svg": 82058,
	"./error.svg": 68067,
	"./eur.png": 69277,
	"./exp-date.svg": 34417,
	"./facebook-dark.svg": 27030,
	"./facebook.svg": 3536,
	"./fees@2x.svg": 60834,
	"./figures_up_arrow.png": 21510,
	"./filterIcon.png": 89863,
	"./forexCalculatorTool.png": 23458,
	"./gbp.png": 26640,
	"./google_play_filled.svg": 5128,
	"./icon-add-account.svg": 8623,
	"./icon-approp-test-grey-dark.svg": 70687,
	"./icon-approp-test-grey-light.svg": 29296,
	"./icon-appropiatenessTest.svg": 35295,
	"./icon-appstore@2x.png": 94644,
	"./icon-arrow-right-dark.png": 79198,
	"./icon-arrow-right-light.png": 85828,
	"./icon-beneficiariesDirectors.svg": 44823,
	"./icon-close-dark.svg": 38037,
	"./icon-close-light.svg": 58815,
	"./icon-close.png": 72513,
	"./icon-contact-callback@2x.png": 20853,
	"./icon-contact-chat@2x.png": 43235,
	"./icon-contact-complaintForm@2x.png": 53353,
	"./icon-contact-email@2x.png": 14791,
	"./icon-contact-faqs@2x.png": 60618,
	"./icon-contact-oneOnOneSession@2x.png": 73280,
	"./icon-contact-telegram@2x.png": 87250,
	"./icon-contact-whatsapp@2x.png": 62557,
	"./icon-documents-grey-dark.svg": 66100,
	"./icon-documents-grey-light.svg": 29907,
	"./icon-documents.svg": 67822,
	"./icon-economic-profile-grey-dark.svg": 82824,
	"./icon-economic-profile-grey-light.svg": 8171,
	"./icon-facebook@2x.png": 19704,
	"./icon-financialInformation.svg": 94350,
	"./icon-general.svg": 58910,
	"./icon-google-play@2x.png": 5530,
	"./icon-local-depositor-grey-dark.svg": 58688,
	"./icon-local-depositor-grey-light.svg": 17340,
	"./icon-local-depositor.svg": 55731,
	"./icon-personal-profile-grey-dark.svg": 2852,
	"./icon-personal-profile-grey-light.svg": 82170,
	"./icon-representative.svg": 71303,
	"./icon-signing.svg": 99582,
	"./icon-spoa-grey-dark.svg": 10549,
	"./icon-spoa-grey-light.svg": 43658,
	"./icon-spoa.svg": 79817,
	"./icon-swapFree.svg": 48571,
	"./icon-swapFreeAccount.svg": 15615,
	"./icon-swapfree-grey-dark.svg": 89340,
	"./icon-swapfree-grey-light.svg": 42761,
	"./icon-telegram@2x.png": 41982,
	"./icon-twitter@2x.png": 94069,
	"./info.svg": 41710,
	"./instagram-dark.svg": 11318,
	"./instagram.svg": 55397,
	"./jcb.png": 14501,
	"./language-dark.svg": 36734,
	"./language-light.svg": 71680,
	"./languages.png": 18431,
	"./limit-failure-dark.png": 35918,
	"./limit-failure-light.png": 25522,
	"./lineQRcode.png": 78141,
	"./link-icon.svg": 12221,
	"./linkedin-dark.svg": 85200,
	"./linkedin.svg": 57657,
	"./logo-accuracy.png": 57010,
	"./logo-bdstrading-white.svg": 94689,
	"./logo-bdstrading.svg": 88127,
	"./logo-bdswiss-white.svg": 20598,
	"./logo-bdswiss.png": 16596,
	"./logo-bdswiss.svg": 21138,
	"./logo-facebook.png": 62131,
	"./logo-google.png": 94968,
	"./logo-regalx-white.png": 5562,
	"./logo-regalx.png": 26349,
	"./logo-swissmarkets-white.svg": 93851,
	"./logo-swissmarkets.png": 5799,
	"./logo-swissmarkets.svg": 25389,
	"./logo-viverno-white.png": 17392,
	"./logo-viverno.png": 66660,
	"./logout.svg": 16301,
	"./loyaltyProgram-dark.svg": 88783,
	"./loyaltyProgram-light.svg": 23589,
	"./maestro.png": 65428,
	"./market_analysis_post.svg": 15582,
	"./mastercard.png": 84196,
	"./mercedesCup-dark.svg": 10565,
	"./mercedesCup-light.svg": 36575,
	"./mobile/accounts-dark.svg": 82753,
	"./mobile/accounts-light.svg": 50289,
	"./mobile/accounts.svg": 4515,
	"./mobile/more.svg": 25716,
	"./mobile/notifications.svg": 23225,
	"./mobile/payments.svg": 76580,
	"./moreBottomNav.svg": 49754,
	"./nationalIdBR.png": 1724,
	"./nationalIdES.jpg": 82592,
	"./nationalIdIT.jpg": 47266,
	"./nationalIdZA.png": 6857,
	"./no-trades-dark.png": 26728,
	"./no-trades-light.png": 75399,
	"./no-trading-signals-dark.png": 63327,
	"./nok.png": 42650,
	"./notifications-dark.svg": 54567,
	"./notifications-empty-dark.png": 80087,
	"./notifications-empty-light.png": 30907,
	"./notifications-icon.svg": 95780,
	"./notifications-light.svg": 18902,
	"./onlineBanking.svg": 24107,
	"./onlineDeposit.svg": 94971,
	"./open-links-purple.svg": 23505,
	"./open-links-white.svg": 53131,
	"./open-links.svg": 43780,
	"./otherPof.svg": 69036,
	"./page-not-found-dark.svg": 55019,
	"./page-not-found-light.svg": 99148,
	"./partnerNav.svg": 65802,
	"./partnerZone-dark.svg": 9662,
	"./partnerZone-light.svg": 5834,
	"./partnerZoneButtonNav.svg": 32180,
	"./payment-failure-dark.png": 28346,
	"./payment-failure-light.png": 55166,
	"./payment-pending-dark.png": 83248,
	"./payment-pending-light.png": 57697,
	"./payment-success-dark.png": 66921,
	"./payment-success-light.png": 94460,
	"./payments-history-empty-dark.png": 10543,
	"./payments-history-empty-light.png": 20667,
	"./paymentsBottomNav.svg": 4295,
	"./phone_verification.png": 92678,
	"./place1-leadership.png": 55592,
	"./place2-leadership.png": 22203,
	"./place3-leadership.png": 13886,
	"./pln.png": 40881,
	"./pof-bankStatement.png": 18138,
	"./pof-bankStatementPOF.png": 81402,
	"./pof-card-back.png": 47602,
	"./pof-card.png": 40225,
	"./pof-cardStatement.png": 39951,
	"./pof-other.png": 86961,
	"./pof-proofOfResidence.png": 54225,
	"./pof-swiftCopyPaymentAdvice.png": 2039,
	"./pof-virtualCard.png": 78561,
	"./poi-document.png": 70129,
	"./poi-drivingLicense-back.png": 12544,
	"./poi-drivingLicense.png": 57540,
	"./poi-id-back.png": 5376,
	"./poi-id.png": 39508,
	"./poi-passport.png": 2230,
	"./por-bankStatementPOR.png": 57694,
	"./por-document.png": 76407,
	"./por-hukou-back.png": 39488,
	"./por-hukou.png": 66637,
	"./por-hukouBook-back.png": 67558,
	"./por-hukouBook.png": 1697,
	"./por-proofOfResidence.png": 78549,
	"./por-utilityBill.png": 21900,
	"./priority@2x.svg": 91958,
	"./profile-icon.svg": 44178,
	"./profileSettings-dark.svg": 50743,
	"./profileSettings-light.svg": 46013,
	"./promoMaterialsCopyCodeButton.svg": 38986,
	"./promoMaterialsDownloadButton.svg": 20868,
	"./promotions-dark.svg": 99463,
	"./promotions-light.svg": 42005,
	"./promotionsCheck.svg": 49025,
	"./promotionsChevron.svg": 62467,
	"./promotionsGift.png": 43923,
	"./promotionsGiftGray.png": 95094,
	"./promotionsRocket.png": 24700,
	"./promotionsSad.svg": 56273,
	"./promotionsStar.svg": 9555,
	"./qr-apk-dark.png": 31805,
	"./qr-apk-light.png": 32712,
	"./qr-store-dark.png": 19932,
	"./qr-store-light.png": 61832,
	"./qr-сode-icon.svg": 30833,
	"./qrCodeIcon.svg": 18969,
	"./referAndEarn.png": 73587,
	"./refer_become_ib.png": 588,
	"./refer_icon.png": 84327,
	"./regalxDemo_downloadMT4.png": 61114,
	"./regalxReal01_downloadMT4.png": 10657,
	"./regalxReal02_downloadMT4.png": 47528,
	"./regalxReal03_downloadMT4.png": 22562,
	"./regalxReal04_downloadMT4.png": 40279,
	"./regalxReal05_downloadMT4.png": 6843,
	"./register-referral-light.png": 96543,
	"./rounded-arrow-left-dark.svg": 45431,
	"./rounded-arrow-left-light.svg": 80657,
	"./rounded-arrow-right-dark.svg": 93747,
	"./rounded-arrow-right-light.svg": 90439,
	"./sadFace.svg": 23993,
	"./sek.png": 98380,
	"./settings_gear_icon.svg": 71879,
	"./sign-up.png": 6457,
	"./spaceship.png": 79414,
	"./spreads@2x.svg": 63064,
	"./star.svg": 83111,
	"./success.svg": 41185,
	"./suitcase-grey.svg": 64090,
	"./suitcase-white.svg": 49873,
	"./suitcase.svg": 4831,
	"./support-dark.svg": 93285,
	"./support-light.svg": 12448,
	"./support@2x.svg": 61551,
	"./supportBottomNav.svg": 16226,
	"./supportMobile-dark.svg": 26140,
	"./supportMobile-light.svg": 83607,
	"./swissmarketsDemo_downloadMT4.png": 26666,
	"./swissmarketsReal02_downloadMT4.png": 29514,
	"./swissmarketsReal_downloadMT4.png": 78856,
	"./technicalIndicator-ebook.png": 58732,
	"./technicalIndicatorItem.svg": 41260,
	"./telegram-dark.png": 43556,
	"./telegram-dark.svg": 52873,
	"./telegram.png": 98984,
	"./telegram.svg": 40351,
	"./telegramGroupTool.png": 7679,
	"./telegramVIPAlertsTool.png": 42089,
	"./theme-dark.svg": 46185,
	"./theme-light.svg": 28869,
	"./tick.svg": 62186,
	"./tiktok-dark.svg": 48665,
	"./tiktok.svg": 14044,
	"./tools-dark.svg": 73982,
	"./tools-light.svg": 68407,
	"./tradeCompanionTool.png": 91507,
	"./trade_300.svg": 21539,
	"./trading-alerts-tradingAlerts-dark.png": 35463,
	"./trading-alerts-tradingAlerts-light.png": 11230,
	"./tradingAcademyTool.png": 54611,
	"./tradingCentralTool.png": 74875,
	"./tradingPsychology-ebook.png": 1271,
	"./tradingPsychologyItem.svg": 66147,
	"./transfer-external.svg": 52487,
	"./transfer-internal.svg": 20850,
	"./transfer-spoa.svg": 14209,
	"./transfer_sync_arrows.svg": 81148,
	"./transfer_sync_arrows_300.svg": 1043,
	"./trash-delete-remove.png": 66005,
	"./unverified.svg": 39289,
	"./unverifiedDark.svg": 22308,
	"./unverifiedNew.svg": 10582,
	"./upload-bankStatement-error.png": 59560,
	"./upload-bankStatement-success.png": 66024,
	"./upload-bankStatement.png": 67659,
	"./upload-document-dark.png": 93183,
	"./upload-document-light.png": 94442,
	"./upload-generic-error.png": 5318,
	"./upload-generic-success.png": 43618,
	"./upload-generic.png": 9334,
	"./upload-icon-error.png": 73866,
	"./upload-icon.png": 25113,
	"./upload-pof-back-card-error.png": 38373,
	"./upload-pof-back-card-success.png": 96493,
	"./upload-pof-back-card.png": 37686,
	"./upload-pof-front-card-error.png": 13407,
	"./upload-pof-front-card-success.png": 4140,
	"./upload-pof-front-card.png": 14686,
	"./upload-poi-back-drivingLicense-error.png": 34988,
	"./upload-poi-back-drivingLicense-success.png": 26897,
	"./upload-poi-back-drivingLicense.png": 22393,
	"./upload-poi-back-error.png": 26628,
	"./upload-poi-back-success.png": 63522,
	"./upload-poi-back.png": 48976,
	"./upload-poi-front-drivingLicense-error.png": 92094,
	"./upload-poi-front-drivingLicense-success.png": 18446,
	"./upload-poi-front-drivingLicense.png": 4613,
	"./upload-poi-front-error.png": 37000,
	"./upload-poi-front-success.png": 78761,
	"./upload-poi-front.png": 38151,
	"./upload-por-front-error.png": 26422,
	"./upload-por-front-proofOfResidence-error.png": 97207,
	"./upload-por-front-proofOfResidence-success.png": 65209,
	"./upload-por-front-proofOfResidence.png": 5393,
	"./upload-por-front-success.png": 89195,
	"./upload-por-front-utilityBill-error.png": 99971,
	"./upload-por-front-utilityBill-success.png": 98822,
	"./upload-por-front-utilityBill.png": 80795,
	"./upload-por-front.png": 34363,
	"./usd.png": 52751,
	"./user_avatar_300.svg": 37787,
	"./verified.svg": 17013,
	"./verifiedIcon.svg": 13674,
	"./verifiedIconDark.svg": 80167,
	"./vipAccountAdvantage.png": 92834,
	"./vipAccountAdvantage2.png": 91397,
	"./vipAccountAdvantage3.png": 7134,
	"./vipAccountAdvantage4.png": 17391,
	"./vipAccountAdvantage5.png": 52938,
	"./vipAccountAdvantage6.png": 69551,
	"./vipAccountAdvantage7.png": 24135,
	"./vipAccountAdvantage8.png": 7174,
	"./visa.png": 89511,
	"./visibilityNew.svg": 21102,
	"./visibilityNewDark.svg": 43915,
	"./visibilityOff.svg": 3995,
	"./visibilityOffDark.svg": 1213,
	"./viverno_app_logo.svg": 13912,
	"./vps-enter-credentials.png": 86937,
	"./vps-remote-desktop-windows.png": 70683,
	"./vps-remote-desktop.png": 75899,
	"./vpsTool.png": 91781,
	"./waiting-list-skip-dark.png": 84756,
	"./waiting-list-skip.png": 40441,
	"./warning.svg": 64370,
	"./website-icon.svg": 90868,
	"./windows-brands.svg": 22924,
	"./withdraw_upload.svg": 35991,
	"./x-dark.svg": 61401,
	"./x.svg": 91275,
	"./youtube-dark.svg": 97834,
	"./youtube.svg": 63672,
	"./zar.png": 15933,
	"./zuluTrade-image-dark-mobile.png": 50906,
	"./zuluTrade-image-dark.png": 54915,
	"./zuluTrade-image-light-mobile.png": 44758,
	"./zuluTrade-image-light.png": 80945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;